import {
  initializeFaro,
  getWebInstrumentations,
  type Faro,
} from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import z from 'zod'

declare module '#app' {
  interface NuxtApp {
    $grafanaFaro?: Faro
  }
}

const options = z.object({
  collectUrl: z.string().min(1),
  environment: z.string().min(1),
})

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const result = options.safeParse(config.public.grafana)

  if (!result.success) {
    if (import.meta.dev) {
      console.warn(
        '[Faro] skipping grafana initialization (no collectUrl found)',
      )
    }
    return
  }

  const sessionTrackingConfig = {
    samplingRate: 0.01,
  }

  const faro = initializeFaro({
    url: result.data.collectUrl,
    app: {
      name: 'Provet',
      version: '1.0.0',
      environment: result.data.environment,
    },
    sessionTracking: sessionTrackingConfig,
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true,
      }),
      new TracingInstrumentation(),
    ],
  })

  return {
    provide: {
      grafanaFaro: faro,
    },
  }
})
